import axios from "axios";

const DEFAULT_TIMEOUT = 10000;

const client = axios.create({
  timeout: DEFAULT_TIMEOUT,
});

export default client;
